import { ActionConfig, ActionType, ReviewResult, TooltipId } from "./types";
import { PreviewBorderColor } from "../DataList";
import XIcon from "assets/icons/FloatIcons/XIcon";
import CheckIcon from "assets/icons/FloatIcons/CheckIcon";
import IgnoreIcon from "assets/icons/FloatIcons/IgnoreIcon";
import AddTagIcon from "assets/icons/AddTagIcon";

export const getBorderColorByResult: Record<
  ReviewResult,
  PreviewBorderColor | undefined
> = {
  CORRECT: "green",
  INCORRECT: "red",
  IGNORE: undefined,
  REASSIGN: "red",
  INFERRED: "green",
  REVERT: undefined,
};

export const getOpacityByResult: Record<ReviewResult, number> = {
  CORRECT: 100,
  INCORRECT: 100,
  IGNORE: 50,
  REASSIGN: 100,
  INFERRED: 100,
  REVERT: 100,
};

export const TOOLTIP_TEXT: Record<ActionType, Record<TooltipId, string>> = {
  SINGLE: {
    INCORRECT:
      "Decline: This image does not belong to the current label. It will be reassigned to the next-best predicted label and marked for review.",
    CORRECT: "Approve: This image correctly belongs to the current label.",
    IGNORE:
      "Ignore: This image doesn't fit any label. It will be excluded from labeling and placed in an 'Unlabeled' group.",
    REASSIGN:
      "Reassign: Move this image to the correct label based on your knowledge.",
  },
  BULK: {
    INCORRECT:
      "Decline: These images do not belong to the current label. They will be reassigned to the next-best predicted label and marked for review.",
    CORRECT: "Approve: These images correctly belong to the current label.",
    IGNORE:
      "Ignore: These images don't fit any label. They will be excluded from labeling and placed in an 'Unlabeled' group.",
    REASSIGN:
      "Reassign: Move these images to the correct label based on your knowledge.",
  },
};

export const getTooltipText = (actionType: ActionType, id: TooltipId): string =>
  TOOLTIP_TEXT[actionType][id];

export const actionListConfigs: ActionConfig[] = [
  {
    text: "approve",
    icon: <CheckIcon />,
    color: "success",
    result: "CORRECT",
  },
  {
    text: "reassign",
    icon: <AddTagIcon />,
    color: "primary",
    result: "REASSIGN",
    hasSubAction: true,
  },
  {
    text: "ignore",
    icon: <IgnoreIcon />,
    color: "warning",
    result: "IGNORE",
  },
  {
    text: "decline",
    icon: <XIcon />,
    color: "danger",
    result: "INCORRECT",
    needsConfirmation: true,
  },
];

export const getResultByType = (result: ReviewResult | null) => {
  if (!result) return { value: "For Review", type: "default" as const };

  if (result === "INFERRED") {
    return { value: "Annotated", type: "success" as const };
  } else if (result === "IGNORE") {
    return { value: "Ignored", type: "danger" as const };
  } else {
    return { value: "Reviewed", type: "success" as const };
  }
};

export const getVLColorByActionColor: Record<PreviewBorderColor, string> = {
  red: "var(--focus-active-states-color-error-focus)",
  green: "var(--focus-active-states-color-success-focus)",
};
